import React from "react";

/**
 * Four-segment ring with a bar, drawn here rather than using Google's asset.
 *
 * NOTE for launch: Google's branding guidelines require their official
 * "Sign in with Google" button and mark on the real consent entry point. This
 * placeholder is deliberately not their logo — swap it for the official asset
 * before this ships to customers.
 */
export function ProviderMark({ className = "h-4 w-4" }: { className?: string }) {
    return (
        <svg viewBox="0 0 24 24" className={className} aria-hidden="true" fill="none">
            <path d="M18.55 16.59 A 8 8 0 0 0 17.25 5.96" stroke="#4285F4" strokeWidth="3.1" strokeLinecap="round" />
            <path d="M17.25 5.96 A 8 8 0 0 0 6.54 6.15" stroke="#EA4335" strokeWidth="3.1" strokeLinecap="round" />
            <path d="M6.54 6.15 A 8 8 0 0 0 5.61 16.81" stroke="#FBBC05" strokeWidth="3.1" strokeLinecap="round" />
            <path d="M5.61 16.81 A 8 8 0 0 0 16.12 18.86" stroke="#34A853" strokeWidth="3.1" strokeLinecap="round" />
            <path d="M12.4 12 H 19.2" stroke="#4285F4" strokeWidth="3.1" strokeLinecap="round" />
        </svg>
    );
}

export default ProviderMark;
